module.exports = __webpack_public_path__ + "img/box7-6-6.15abef3b.png";